import LeadStatisticsCard from "../../components/FleetCRM/LeadStatisticsCard/LeadStatisticsCard";

const CRMHomepage = () => {
  return <LeadStatisticsCard />;
};

export default CRMHomepage;
